import React, { Fragment, useEffect, useState } from 'react';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { BulbIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Bulb';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';

import { useUserContext } from '~/contexts/UserContext';
import { getABCNode, MARKETPLACE_VDP_VALUE_PROPS } from '~/util/experimentFlags';

import styles from './valuePropComponent.module.less';

export const ValuePropTest1 = (): JSX.Element => {
  return (
    <div className={styles.valueProp}>
      <div className={styles.dek}>
        <H.Title6 className={styles.hed}>
          {' '}
          <BulbIcon width={24} height={24} className={styles.icon} />{' '}
          <strong>Why reach out on Zola?</strong>
        </H.Title6>
        <ul className={styles.list}>
          <li>All your quotes in one place</li>
          <li>Quick responses from vendors</li>
          <li>Personalized recs using your preferences</li>
        </ul>
      </div>
    </div>
  );
};

export const ValuePropTest2 = (): JSX.Element => {
  return (
    <div className={styles.valueProp}>
      <div>
        <div>
          <div className={styles.promoTag}>
            <P.BodySmall color="WHITE_100">Get 30% off save the dates</P.BodySmall>
          </div>
        </div>
        <div>
          <P.BodyBase className={styles.promoText}>
            <strong>
              Reach out to vendors on Zola to unlock your 30% discount.{' '}
              <LinkV2 href="/discount-terms/1025071" target="_blank">
                Details
              </LinkV2>
            </strong>
          </P.BodyBase>
        </div>
      </div>
    </div>
  );
};

const ValuePropComponent = () => {
  const userContext = useUserContext();
  const [valuePropContent, setValuePropContent] = useState(<Fragment />);

  useEffect(() => {
    setValuePropContent(
      getABCNode(
        userContext,
        MARKETPLACE_VDP_VALUE_PROPS,
        <Fragment />,
        <ValuePropTest1 />,
        <ValuePropTest2 />
      )
    );
  }, [userContext]);

  return <div>{valuePropContent}</div>;
};

export default ValuePropComponent;
